export default {
  REGEX_LEGAL_NAME_VALIDATION: /^(?=.*[A-Za-zÀ-ÿ])[A-Za-zÀ-ÿ ',.-]+$/,
  REGEX_PHONE_VALIDATION:
    /^1?[-. ]?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
  REGEX_ZIPCODE_VALIDATION: /(^\d{5}$)|(^\d{5}-?\d{4}$)/,
};
